export default __webpack_public_path__ + "static/media/567.8321e033.gif";